// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._mgik{align-items:center;padding:2px 8px;border-radius:100px;border:1px solid transparent;font-family:"Lufga-Medium";font-weight:400;font-size:var(--font-size-p2, 12px);line-height:var(--line-height-p2, 16px);letter-spacing:.02em}._mgik.qxXX3{background-color:#f3fcfa;border-color:#b6ebdf;color:#089475}._mgik.YseOu{background-color:#f4f4f7;border-color:#d4d4e0;color:#7e7ea1}.rrIEe{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:0}.QRDQF{background-color:#f4f4f7;display:flex;flex-direction:column}.KLhze{background-color:#fff;border-bottom:1px solid #d4d4e0;box-shadow:0px 4px 12px rgba(40,40,99,.06)}.DpWNO{margin:24px 32px 32px;background-color:#fff;border-radius:8px;box-shadow:0px 4px 12px rgba(40,40,99,.06);flex:1 0 auto}.DpWNO.bqHfZ{margin:12px 16px 16px;border-radius:6px}.GfGvf{display:flex;gap:32px;align-items:start}.GfGvf.aBRtk{flex-direction:column;gap:24px;align-items:stretch}.lkhN9{flex:1;min-width:0}.SktLm{flex:0 0 500px}.aBRtk .SktLm{flex:1 1 auto;width:100%}.vMinz{align-self:flex-start;margin-top:0;margin-right:14px}._2nKl9{max-width:100%;min-width:0}.aBRtk ._2nKl9{overflow:hidden}.hs7W7{position:sticky;top:0;z-index:1;padding:0 32px;background-color:#f4f4f7}.hs7W7.npmN5{padding:0 16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"fontFamilyLight": `"Lufga-Regular"`,
	"fontFamilyNormal": `"Lufga-Medium"`,
	"fontFamilyBold": `"Lufga-SemiBold"`,
	"fontSizeH1": `var(--font-size-h1, 40px)`,
	"fontSizeH2": `var(--font-size-h2, 36px)`,
	"fontSizeH3": `var(--font-size-h3, 28px)`,
	"fontSizeH4": `var(--font-size-h4, 24px)`,
	"fontSizeH5": `var(--font-size-h5, 20px)`,
	"fontSizeH6": `var(--font-size-h6, 18px)`,
	"fontSizeP1": `var(--font-size-p1, 14px)`,
	"fontSizeP2": `var(--font-size-p2, 12px)`,
	"fontSizeP3": `var(--font-size-p3, 10px)`,
	"lineHeightH1": `var(--line-height-h1, 56px)`,
	"lineHeightH2": `var(--line-height-h2, 52px)`,
	"lineHeightH3": `var(--line-height-h3, 36px)`,
	"lineHeightH4": `var(--line-height-h4, 34px)`,
	"lineHeightH5": `var(--line-height-h5, 32px)`,
	"lineHeightH6": `var(--line-height-h6, 30px)`,
	"lineHeightP1": `var(--line-height-p1, 22px)`,
	"lineHeightP2": `var(--line-height-p2, 16px)`,
	"lineHeightP3": `var(--line-height-p3, 14px)`,
	"statusBadge": `_mgik`,
	"active": `qxXX3`,
	"inactive": `YseOu`,
	"title": `rrIEe`,
	"modalContent": `QRDQF`,
	"modalHeader": `KLhze`,
	"card": `DpWNO`,
	"cardMobile": `bqHfZ`,
	"bodyGrid": `GfGvf`,
	"bodyGridMobile": `aBRtk`,
	"contentColumn": `lkhN9`,
	"previewColumn": `SktLm`,
	"messageAdornment": `vMinz`,
	"fieldContainer": `_2nKl9`,
	"stickyTabs": `hs7W7`,
	"stickyTabsMobile": `npmN5`
};
export default ___CSS_LOADER_EXPORT___;
